export default "__VITE_ASSET__DWcqG_oA__"